import { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import Logo from "@/components/Logo";
import { SITE, waLink } from "@/lib/site";

const LINKS = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/destinations", label: "Destinations" },
    { to: "/packages", label: "Packages" },
    { to: "/services", label: "Services" },
    { to: "/testimonials", label: "Stories" },
    { to: "/contact", label: "Contact" },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 20);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => { setOpen(false); }, [pathname]);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                scrolled ? "glass-nav" : "bg-transparent"
            }`}
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 h-20 flex items-center justify-between">
                <Link to="/" data-testid="brand-logo">
                    <Logo />
                </Link>

                <nav className="hidden lg:flex items-center gap-8">
                    {LINKS.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            end={l.to === "/"}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className={({ isActive }) =>
                                `font-sans text-sm tracking-wide transition-colors ${
                                    isActive ? "text-gold" : "text-white/70 hover:text-white"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-4">
                    <a
                        href={waLink()}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="nav-cta-book"
                        className="bg-gold text-navy hover:bg-[#E5C158] px-6 py-3 font-sans font-medium uppercase tracking-wider text-xs transition-colors duration-300"
                    >
                        Book Now
                    </a>
                </div>

                <button
                    data-testid="mobile-menu-toggle"
                    className="lg:hidden text-white"
                    onClick={() => setOpen((v) => !v)}
                    aria-label="Menu"
                >
                    {open ? <X size={26} weight="light" /> : <List size={26} weight="light" />}
                </button>
            </div>

            {open && (
                <div className="lg:hidden glass-nav border-t border-white/10" data-testid="mobile-menu">
                    <div className="px-6 py-6 flex flex-col gap-4">
                        {LINKS.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                end={l.to === "/"}
                                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                                className={({ isActive }) =>
                                    `font-serif text-2xl ${isActive ? "text-gold" : "text-white/80"}`
                                }
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <a
                            href={waLink()}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="mobile-nav-book"
                            className="mt-4 bg-gold text-navy px-6 py-4 text-center font-sans uppercase tracking-wider text-sm"
                        >
                            Book via WhatsApp
                        </a>
                        <p className="text-white/50 text-xs mt-2">{SITE.whatsappDisplay} · {SITE.email}</p>                    </div>
                </div>
            )}
        </header>
    );
}
